/*
  Zeus Home Products Grid — entree "foudre" grid-aware + strike badge.
  Systeme motion : zeus-gsap (GSAP core + ScrollTrigger). PAS un 3e systeme.
  Degradation : si GSAP absent ou prefers-reduced-motion -> cartes visibles
  par defaut (l'etat initial cache n'est pose que quand JS arme la grille).
*/
(function () {
  "use strict";

  function waitForGsap(callback) {
    if (typeof window.zeusWhenGsapReady === "function") {
      window.zeusWhenGsapReady(callback);
      return;
    }
    if (window.gsap && window.ScrollTrigger) callback();
  }

  function initGrid(grid) {
    if (grid.dataset.zeusHpgChargeInit === "true") return;
    grid.dataset.zeusHpgChargeInit = "true";

    if (!window.gsap || !window.ScrollTrigger) {
      return;
    }

    var gsap = window.gsap;
    gsap.registerPlugin(window.ScrollTrigger);

    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var items = Array.prototype.slice.call(grid.children);
    if (!items.length || reduce) return;

    // Arm the hidden state only when the grid is close enough to animate.
    grid.classList.add("is-charge-armed");
    gsap.set(items, { opacity: 0, y: 42 });

    function revealBatch(batch) {
      gsap.to(batch, {
        opacity: 1,
        y: 0,
        duration: 0.7,
        stagger: 0.07,
        ease: "back.out(1.4)",
        clearProps: "transform",
      });
      batch.forEach(function (item, index) {
        var badge = item.querySelector(".zeus-hpg-card__badge--range");
        if (!badge) return;
        gsap.delayedCall(index * 0.07 + 0.42, function () {
          badge.classList.add("is-strike");
        });
      });
    }

    window.ScrollTrigger.batch(items, {
      start: "top 90%",
      onEnter: revealBatch,
      onEnterBack: revealBatch,
    });
  }

  function boot() {
    document.querySelectorAll(".zeus-hpg__grid[data-zeus-hpg-charge]").forEach(function (grid) {
      var initialize = function () {
        waitForGsap(function () {
          initGrid(grid);
        });
      };

      if (typeof window.zeusWhenNearViewport === "function") {
        window.zeusWhenNearViewport(grid, initialize);
      } else {
        initialize();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
